import { CoverageLookupCard } from "@/components/coverage/CoverageLookupCard";
import { CoverageMap } from "@/components/coverage/CoverageMap";
import { CoveragePartyEditor } from "@/components/coverage/CoveragePartyEditor";
import { useCoverageBoard } from "@/components/coverage/useCoverageBoard";

export function CoverageAssistantPanel() {
  const board = useCoverageBoard();
  return (
    <div className="flex h-full min-h-[640px] flex-col gap-3 p-3 lg:flex-row">
      <div className="flex w-full flex-col gap-3 lg:w-96 lg:shrink-0">
        {board.loadError ? <p className="text-sm text-red-600">{board.loadError}</p> : null}
        <CoverageLookupCard
          address={board.address}
          program={board.program}
          busy={board.lookupBusy}
          error={board.lookupError}
          precision={board.precision}
          point={board.point}
          hits={board.hits}
          onAddress={board.setAddress}
          onProgram={board.setProgram}
          onLookup={() => void board.lookup()}
        />
        <CoveragePartyEditor
          parties={board.parties}
          areas={board.areas}
          draft={board.draft}
          busy={board.saving}
          error={board.saveError}
          drawing={board.drawing}
          onChange={board.setDraft}
          onSelect={board.selectParty}
          onSave={() => void board.save()}
          onDraw={() => board.setDrawing(true)}
        />
      </div>
      <div className="min-h-[420px] flex-1">
        <CoverageMap
          parties={board.parties}
          areas={board.areas}
          locations={board.locations}
          customer={board.point}
          draftPolygon={board.draftPolygon}
          drawing={board.drawing}
          onPolygon={board.acceptPolygon}
        />
      </div>
    </div>
  );
}
